import React, { useState, useEffect } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from '@mui/material';
import { Task } from '../types';

interface TaskModalProps {
    open: boolean;
    task: Task;
    onClose: () => void;
    onSave: (task: Task) => void;
    onDelete: (task: Task) => void;
    setTask: (task: Task) => void;
}

export default function TaskModal(props: TaskModalProps) {
    const { open, task, onClose, onSave, onDelete, setTask } = props;

    const [name, setName] = useState(task?.name || '');
    const [color, setColor] = useState(task?.color || '#000000');

    useEffect(() => {
        setName(task?.name || '');
        setColor(task?.color || '#000000');
    }, [task]);

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>{task ? 'Edit task' : 'Create task'}</DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    margin="dense"
                    id="name"
                    label="Name"
                    type="text"
                    fullWidth
                    value={name}
                    onChange={(e) => setTask({ ...task, name: e.target.value })}
                 />
                <TextField
                    margin="dense"
                    id="color"
                    label="Color"
                    type="color"
                    fullWidth
                    value={color}
                    onChange={(e) => setTask({...task, color: e.target.value})}
                />
            </DialogContent>
            <DialogActions>
                {task.id_task &&
                    <Button onClick={() => onDelete(task)}>Delete</Button>}
                <Button onClick={onClose}>Cancel</Button>
                <Button onClick={() => onSave(task)}>{task.id_task ? 'Save' : 'Create'}</Button>
            </DialogActions>
        </Dialog>
    );
}